/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import get from "lodash/get";
import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { decodeURIFromWidget } from "../../../../utils/decodeCustomCode";
import { AdService } from "../../../components/ad-service";
import { WidgetComponent } from "../../../components/Widget";
import "./arrow.m.css";

// this will be the wrapper inside ahead
const arrowWrapper = Component => ({ collection = {}, metadata = {} }) => {
  const pageType = useSelector(state => get(state, ["qt", "pageType"], ""), shallowEqual);
  const supportedPages = {
    "home-page": "home",
    "section-page": "section",
    "collection-page": "section",
    "tag-page": "tag",
    "author-page": "author",
    "pagebuilder-section-preview-page": "section",
    "pagebuilder-collection-preview-page": "section",
    "pagebuilder-story-preview-page": "story",
    "authors-page": "authors",
    "": ""
  };

  const theme = useSelector(
    state => get(state, ["qt", "config", "pagebuilder-config", supportedPages[pageType], "pageSetting", "bgColor"], ""),
    shallowEqual
  );

  const { "pagebuilder-config": pbconfig, "theme-attributes": themeAttributes } = useSelector(state =>
    get(state, ["qt", "config"])
  );
  const fallbackImageUrl = get(
    pbconfig,
    ["general", "fallbackImage", "url"],
    get(themeAttributes, ["imageFallbackUrl"])
  );

  const config = get(metadata, ["config"], {});
  let { adType = "", targetingId = "", widget = "" } = config;

  const adComponent = () => {
    return (
      <div className="app-ad app-ad--story-horizontal">
        <AdService
          adtype={adType}
          adTargetingId={targetingId}
          layoutName="PageBuilder"
          slotId={`PB-${get(metadata, ["rowId"], "")}`}
        />
      </div>
    );
  };
  const widgetComp = () => {
    try {
      if (typeof window !== "undefined") {
        widget = window.atob(widget);
      } else {
        const bufferedWidget = Buffer.from(widget, "base64");
        widget = bufferedWidget.toString("utf-8");
      }
    } catch (e) {
      widget = "";
    }

    return (
      <div className="app-ad app-ad--story-horizontal">
        <WidgetComponent widgetValue={decodeURIFromWidget(widget)} />
      </div>
    );
  };

  const updateComp = ({ type }) => {
    switch (type) {
      case "ad":
        return adComponent;
      case "widget":
        return widgetComp;
      default:
        return null;
    }
  };

  const updateWithComponent = (config = {}) => {
    const pbRowsConfig = useSelector(state =>
      get(state, ["qt", "config", "pagebuilder-config", "general", "rows"], {})
    );

    // Arrow needs the config values like sectionTagTemplate directly under config prop.
    // TODO: May need to flatten the rowConfig sometime.
    const sectionTagTemplate = get(
      pbRowsConfig,
      ["sectionTag", "template"],
      get(pbRowsConfig, ["sectionTagTemplate"], "solid")
    );

    const collectionNameTemplate = get(pbRowsConfig, ["collectionNameTemplate"], "");
    const borderColor = get(pbRowsConfig, ["sectionTag", "color"], "");
    const collectionNameBorderColor = get(pbRowsConfig, ["titleStyle", "underLineColor"], "");
    // borderColor to change sectionTag color. TODO: rename to sectionTagColor

    const supportedPagesForTitle = ["author-page", "tag-page"];

    const pages = supportedPagesForTitle.includes(pageType);
    config = { ...config, ...collection.config }; // collection.config is available only from section page when it is collectionOfStories.

    let updatedConfig = {
      theme,
      ...config,
      sectionTagTemplate,
      collectionNameTemplate,
      borderColor,
      collectionNameBorderColor,
      fallbackImageUrl,
      ...(pages && { showRowTitle: false })
    };
    const { type } = get(updatedConfig, ["slotConfig", 0], {});

    if (!updatedConfig.slotConfig) return updatedConfig;
    updatedConfig.slotConfig[0].component = updateComp({ type });
    return updatedConfig;
  };

  return (
    <div style={{ maxWidth: "1172px", margin: "auto" }}>
      <Component collection={collection} config={updateWithComponent(config)} />
    </div>
  );
};
export { arrowWrapper };
